import { Container, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
    Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon,
    Delete as DeleteIcon, Search as SearchIcon
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import SelectSupplier from '../../components/Form/SelectSupplier';
import Success from '../../components/Form/Success';
import TextField from '../../components/Form/TextField';
import AlertDialog from '../../components/ui/AlertDialog';
import BoxSlide from '../../components/ui/BoxSlideUI';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import VehicleApi from '../../services/VehicleApi';
import getDefaultGridOptions from '../../utils/componentUtils';
import permissions from '../../utils/Permissions';
import useKeypress from '../../utils/useKeypress';
import { useStyles } from './Style';
import VehicleForm from './VehicleForm';

const opcoes = [
    { url: '/Vehicle', descricao: 'Incluir', state: {openPanelOnLoad: true}},
    { url: '/Vehicle', descricao: 'Pesquisar', state: {}}
]

interface Params {
    openPanelOnLoad: boolean;
}

const Vehicle: React.FC = () => {
    const classes = useStyles();
    const location = useLocation<Params>();
    const [vehicles, setVehicles] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [openedPainel, setOpenedPainel] = React.useState(false);
    const [vehicleCode, setVehicleCode] = useState<number>(0);
    const { user, hasPermission } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("Vehicle");
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const [success, setSuccess] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!hasPermission(permissions.VEHICLE.Search))
            history.replace('NoPermission');
    }, [history, user])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        var data = getValues()
        onSubmit(data)
    }, [history, user]);

    
    //Campos do Form
    interface IFormPanel {
        supplier: any;
        vehiclePlateNumber: any;
        cartPlateNumber: any;
        flagEuroClassification: any;
    }

    //Metodos do form:
    const { handleSubmit, reset, control, getValues, setValue } = useForm<IFormPanel>({
        defaultValues: {
            supplier: {},
            vehiclePlateNumber: '',
            cartPlateNumber: '',
            flagEuroClassification: ''
        }
    });

    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'vehiclePlateNumber',
            label: String(t('vehiclePlateNumber')),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: 'cartPlateNumber',
            label: String(t('cartPlateNumber')),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: "vehicleManufacturer",
            label: String(t('vehicleManufacturer')),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: "renavam",
            label: "Renavam",
            options: {
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },   
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowData[0])
                )
            }
        },     
        
    ]

    const renderButtons = (id: any) => {
        return (
            <AlertDialog
                dialogTitle={t("dialogDeleteTitle")}
                dialogContentText={t("dialogDeleteContentText")}
                cancelTextButton={t("cancelDeleteTextButton")}
                confirmTextButton={t("confirmDeleteTextButton")}
                confirmDialogFunction={() => { handleDeleteItem(id); }}
                Button={
                    <IconButton disabled={!hasPermission(permissions.VEHICLE.Delete)} size='small' edge="end">
                        <DeleteIcon />
                    </IconButton>
                }
            />
        );
    }

    function handleDeleteItem(id: number) {
        VehicleApi.deleteVehicle(id)
                .then(result => {
                    enqueueSnackbar(t("returnSubmitDeleteFormSuccess"), { variant: 'success' });
                }).finally(() => {
                    onSubmit(getValues());
                });
    };

    useKeypress('Escape', () => {
        setOpenedPainel(false);
    });

    useEffect(() => {
        setVehicles([]);
        setLoading(false);
    }, []);

    const onSubmit = async (data: any) => {
        setLoading(true);
        data.pageSize = 10000;

        if (data.supplier?.code !== undefined)
            data.supplierId = data.supplier?.code;
        data.companyId = user.company.companyID;
        data.supplier = null;

        //Buscar por fornecedores do Usuario Fornecedor
        if (user.isSupplier && data.supplierId === undefined)
            data.supplierIds = user.suppliers.map((element: { code: any; }) => Number(element.code));

        VehicleApi.searchVehicle(data)
            .then(result => {
                if (result && result.items) {
                    setVehicles(result);
                }
                else {
                    setVehicles([]);
                }
            }).catch(() => {
                setVehicles([]);
            }).finally(() => {
                setLoading(false);
            });
    };

    const cleanFilters = () => {
        reset({
            supplier: {},
            vehiclePlateNumber: '',
            cartPlateNumber: '',
            flagEuroClassification: ''
        });
    };

    const handleOpenPanelChange = (id: any) => {
        setVehicleCode(id);
        setOpenedPainel(true);
    };

    const callbackDialogHandle = () => {
        setOpenedPainel(false);
        handleSubmit(onSubmit);
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: vehicles?.items ? 'pointer' : ''
                }
            }
        }
    })

    useEffect(() => {
        if (location.state?.openPanelOnLoad)
        {
            setOpenedPainel(true);
            setVehicleCode(0)
        }
    }, [location.state?.openPanelOnLoad])
    
    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Success opcoes={opcoes}/>
                    </div>
                </div>
            </Container>
        )
    else
    return (
        <Container maxWidth={false} component="main">

            <BoxSlide isOpen={openedPainel} onClose={() => { setOpenedPainel(false); /*setWidthGrid("100%")*/ }}>
                <VehicleForm vehicleCode={vehicleCode} handleSetSuccess={setSuccess} clickHandlerCalbkack={callbackDialogHandle} clickHandlerClose={() => { setOpenedPainel(false); setVehicleCode(-1); }} />
            </BoxSlide>

            <PageTitle title={t("pageTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >

                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearch")}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI disabled={!hasPermission(permissions.VEHICLE.Add)} color="secondary" onClick={() => { setOpenedPainel(true); setVehicleCode(0) }} startIcon={<AddIcon />}>{t("add")}</ButtonUI>
                                <ButtonUI onClick={() => cleanFilters()} startIcon={<BackspaceOutlinedIcon />}>{t("clean")}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{t("search")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>

                            <Grid item xs={3} >
                                <SelectSupplier
                                    id="supplier"
                                    name="supplier"
                                    label={t("supplierCode")}
                                    multiple={false}
                                    control={control}
                                    style={{  width: '100%' }}
                                    setValue={setValue}
                                    loadUserSupplier={true}
                                />
                            </Grid>

                            <Grid item xs={1}>
                                <TextField label={t("vehiclePlateNumber")} name="vehiclePlateNumber" mask="aaa9*99" control={control} fullWidth />
                            </Grid>

                            <Grid item xs={1}>
                                <TextField label={t("cartPlateNumber")} name="cartPlateNumber" mask="aaa9*99" control={control} fullWidth />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField label={t("flagEuroClassification")} name="flagEuroClassification" inputProps={{ maxLength: 3 }} control={control} fullWidth />
                            </Grid>

                            <Grid item xs={5}>
                            </Grid>

                        </Grid>
                    </form>

                    {
                        loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={vehicles?.items}
                                    columns={columns}
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: false,
                                        pagination: vehicles?.items ? true : false,
                                        sort: vehicles?.items ? true : false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        onCellClick: (_colData, { colIndex, dataIndex }) => {
                                            if (hasPermission(permissions.VEHICLE.Edit))
                                                if ((vehicles && vehicles.items) && colIndex < 5) {
                                                    handleOpenPanelChange(vehicles.items[dataIndex].id);
                                                }
                                        },
                                    }}
                                />
                            </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )
}
export default Vehicle;
